import React from 'react';
import { XCircle } from 'lucide-react';
export function OldSolutionsSection() {
  return <section className="py-10 px-4 bg-white" data-id="element-145">
      <div className="max-w-3xl mx-auto text-center" data-id="element-146">
        <h2 className="text-2xl font-bold text-[#1e3a5f] mb-6" data-id="element-147">
          Por qué lo que probaste no te sirvió
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8" data-id="element-148">
          {['Una app de presupuesto complicada', 'Un Excel que nunca abres', "Decir 'este mes sí me controlo'", "Intentar ahorrar 'lo que sobre'", "Dejar de comprar 'tonterías' sin plan"].map((item, idx) => <div key={idx} className="flex items-center p-3 bg-slate-50 rounded-lg text-left" data-id="element-149">
              <XCircle className="h-4 w-4 text-slate-400 mr-2 flex-shrink-0" data-id="element-150" />
              <span className="text-slate-600 text-sm" data-id="element-151">{item}</span>
            </div>)}
        </div>

        <div className="bg-slate-900 text-white p-6 rounded-2xl relative overflow-hidden" data-id="element-152">
          <div className="relative z-10" data-id="element-153">
            <p className="text-base mb-3 opacity-90" data-id="element-154">
              Esos métodos duraron lo que dura la motivación.
            </p>
            <p className="text-base mb-4 opacity-90" data-id="element-155">
              Porque tienen un supuesto escondido: <br data-id="element-156" />
              que tú vas a estar tranquila, con tiempo, y con la cabeza libre.
            </p>
            <p className="text-xl font-bold text-[#e63946]" data-id="element-157">
              Pero tú no estás así. Tú estás cansada.
            </p>
          </div>
          <div className="absolute top-0 right-0 -mt-10 -mr-10 w-40 h-40 bg-white opacity-5 rounded-full blur-3xl" data-id="element-158"></div>
        </div>
      </div>
    </section>;
}